import { ScrollingModule } from '@angular/cdk/scrolling';
import { DatePipe, AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { Observable } from 'rxjs';
import { BoolToImgPipe } from '../../../../_infrastructure/pipes';
import { BillingReport } from '../../../clients.models';

@Component({
  selector: 'app-billing-report',
  templateUrl: './billing-report.html',
  styleUrl: './billing-report.css',
    imports: [
    MatDialogModule,
    MatTableModule,
    DatePipe,
    ScrollingModule,
  ]
})

export class BillingReportСomponent {
  public constructor() { }
  @Input() public billingReport: BillingReport | null = null;
  @Input() public tableHeight: number = 100;
  @Input() public summaryMarginLeft: number = 0;
}
